
import { FormState__setValidationResponse_5219762A, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { DTO_InspectionTemplateDetailDto_$reflection } from "../../../Shared/InspectionTemplate.js";
import { string_type, list_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";

export function init() {
    return [new State(new RequestedValue$1(0, []), FormState_get_empty()), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(DTO_InspectionTemplateDetailDto_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/inspection-templates", (Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(1, [Item_1])))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [state, Cmd_none()];
        case 2:
            return [new State(state.Templates, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/inspection-templates/load-predefined", ""], (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(4, [Item_1])))];
        case 3: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                return [new State(state.Templates, FormState__setValidationResponse_5219762A(state.FormState, response_2.fields[0])), Cmd_none()];
            }
            else {
                return [new State(state.Templates, FormState_get_empty()), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_5;
                    return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_3) => {
                        const pr_1 = response_3.arrayBuffer();
                        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(DTO_InspectionTemplateDetailDto_$reflection())));
                    }, refreshOn_1)))(true).then((_arg) => {
                        const result_2 = _arg;
                        return (result_2.tag === 1) ? (Promise.resolve((() => {
                            throw new ValidationOnGetRequest(result_2.fields[0]);
                        })())) : (Promise.resolve(result_2.fields[0]));
                    });
                })), "/api/inspection-templates", (Item_2) => (new Msg(0, [Item_2])), (Item_3) => (new Msg(1, [Item_3])))];
            }
        }
        case 4:
            return [new State(state.Templates, FormState_get_empty()), Cmd_none()];
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.FormState), Cmd_none()];
    }
}

